import { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import style from './layout.module.css';
import ContentSharingHome from "./components/content_sharing/content_sharing_home";

const Layout = () => {
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkMobile = () => {
        setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, [])

  const handleButtonClick = (path) => {
    navigate(path);
  };

  const handleExternalLink = (url) => {
    window.open(url, "_blank");
  };

  return (
    <Fragment>
      <div className = {style.homepageContainer}>
        <div className={style.outerContainer}>
          <div className={style.cardsContainer} style={{paddingTop:'1rem'}}>
            <ContentSharingHome/>
          </div>
        </div>
      </div>  
    </Fragment>
  );
};

export default Layout;
